"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconNoSolid = exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = require("@instructure/ui-svg-images/lib/SVGIcon");

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M213.333333,960 C213.333333,792.64 269.333333,638.293333 362.773333,513.6 L1406.4,1557.22667 C1281.70667,1650.66667 1127.36,1706.66667 960,1706.66667 C548.373333,1706.66667 213.333333,1371.62667 213.333333,960 M1706.66667,960 C1706.66667,1127.36 1650.66667,1281.70667 1557.22667,1406.4 L513.6,362.773333 C638.293333,269.333333 792.64,213.333333 960,213.333333 C1371.62667,213.333333 1706.66667,548.373333 1706.66667,960 M960,0 C429.76,0 0,429.76 0,960 C0,1490.24 429.76,1920 960,1920 C1490.24,1920 1920,1490.24 1920,960 C1920,429.76 1490.24,0 960,0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoSolid = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IconNoSolid, _Component);

  var _super = (0, _createSuper2.default)(IconNoSolid);

  function IconNoSolid() {
    (0, _classCallCheck2.default)(this, IconNoSolid);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(IconNoSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_SVGIcon.SVGIcon, Object.assign({}, this.props, {
        name: "IconNo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconNoSolid.displayName = "IconNoSolid";
  return IconNoSolid;
}(_react.Component);

exports.IconNoSolid = IconNoSolid;
IconNoSolid.glyphName = 'no';
IconNoSolid.variant = 'Solid';
IconNoSolid.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.SVGIcon.propTypes);
var _default = IconNoSolid;
exports.default = _default;